/**
 * There will be one saga file per component
 */
import { takeEvery, fork, all, takeLatest, debounce } from 'redux-saga/effects';
import {
    GET_VIEW_DATA,
    GET_CARD_DATA,
    GET_SEARCH_CARD_DATA,
    GET_LIST_DATA,
    GET_REFINEDFILTER,
    GET_VIEWFILTER,
    GET_APPLIED_FILTERS,
    PUT_FILTEROPTION,
    GET_USERPROFILE,
    GET_PAGEVISIBILITYRULE,
    RESET_CALENDAR_FILTERS,
    GET_CARD_PREVIEW_DETAILS
} from '../actions';
import {
    getViewData,
    getCardData,
    getSearchCardData,
    getListData,
    getCardPreview
} from './ordersSaga';
import getUserProfile from './userProfileSaga';
import getPageVisibilityRule from './pageVisibilityRuleSaga';
import getAppliedFilters from './appliedFilters';
import getViewFilter from './viewFilterSaga';
import { putFilterOptions, resetCalendarFilters } from './setFilterOptionsSaga';
import getRefinedFilters from './refinedFiltersSaga';

function* watchGetViewDataSaga() {
    yield takeEvery(GET_VIEW_DATA, getViewData);
}

function* watchGetCardDataSaga() {
    yield debounce(100, GET_CARD_DATA, getCardData);
}
function* watchGetSearchCardDataSaga() {
    yield takeLatest(GET_SEARCH_CARD_DATA, getSearchCardData);
}
function* watchGetListDataSaga() {
    yield debounce(100, GET_LIST_DATA, getListData);
}
function* watchGetUserProfileSaga() {
    yield takeEvery(GET_USERPROFILE, getUserProfile);
}
function* watchGetPageVisibilityRuleSaga() {
    yield debounce(100, GET_PAGEVISIBILITYRULE, getPageVisibilityRule);
}
function* watchGetAppliedFilters() {
    yield debounce(100, GET_APPLIED_FILTERS, getAppliedFilters);
}
function* watchGetViewFilterSaga() {
    yield debounce(100, GET_VIEWFILTER, getViewFilter);
}
function* watchputFilterOptionsSaga() {
    yield takeEvery(PUT_FILTEROPTION, putFilterOptions);
}
function* watchResetCalendarFiltersSaga() {
    yield takeEvery(RESET_CALENDAR_FILTERS, resetCalendarFilters);
}
function* watchGetRefinedFiltersSaga() {
    yield debounce(100, GET_REFINEDFILTER, getRefinedFilters);
}

function* watchGetCardPreviewDetails() {
    yield takeLatest(GET_CARD_PREVIEW_DETAILS, getCardPreview);
}
export default function* OrdersSaga() {
    yield all([
        fork(watchGetViewDataSaga),
        fork(watchGetCardDataSaga),
        fork(watchGetSearchCardDataSaga),
        fork(watchGetListDataSaga),
        fork(watchGetRefinedFiltersSaga),
        fork(watchGetViewFilterSaga),
        fork(watchGetAppliedFilters),
        fork(watchputFilterOptionsSaga),
        fork(watchGetUserProfileSaga),
        fork(watchGetPageVisibilityRuleSaga),
        fork(watchResetCalendarFiltersSaga),
        fork(watchGetCardPreviewDetails)
    ]);
}
